import { IncidentRosterPerson } from '../Types/Incident';

export type AlphaRange = 'All' | 'A-F' | 'G-L' | 'M-R' | 'S-Z';

export const ALPHA_RANGES: AlphaRange[] = ['All', 'A-F', 'G-L', 'M-R', 'S-Z'];

const RANGE_BOUNDS: Record<Exclude<AlphaRange, 'All'>, [string, string]> = {
  'A-F': ['A', 'F'],
  'G-L': ['G', 'L'],
  'M-R': ['M', 'R'],
  'S-Z': ['S', 'Z'],
};

/**
 * Derive last name from displayName by taking the final word.
 */
export const getLastName = (person: IncidentRosterPerson): string => {
  const parts = person.displayName.trim().split(/\s+/);
  return parts.length > 0 ? parts[parts.length - 1] : '';
};

/**
 * Check whether a person's last name falls within the given alpha range.
 * Returns true for 'All'.
 */
export const personMatchesAlphaRange = (person: IncidentRosterPerson, range: AlphaRange): boolean => {
  if (range === 'All') return true;
  const lastName = getLastName(person);
  if (!lastName) return false;
  const firstChar = lastName.charAt(0).toUpperCase();
  const [start, end] = RANGE_BOUNDS[range];
  return firstChar >= start && firstChar <= end;
};
